import { ERowMovementTypes } from "api/enums";
import { IRowMovement } from "api/interfaces";
import ContractRowModel from "./ContractRowModel";
import UserModel from "./UserModel";

class ContractRowMovementModel {
  public readonly contractUid: string;
  public readonly uid: string;
  public readonly structured: string;
  public isStage: boolean;
  public data: { [key: number]: IRowMovement };
  public allAttachments: string[];

  constructor(
    uid: string,
    contractUid: string = "",
    structured: string = "",
    isStage: boolean = false,
    data: { [key: number]: IRowMovement } = {},
    allAttachments: string[] = []
  ) {
    Object.entries(data).forEach(([key, value]) => {
      const indicatorDate = value?.indicatorDate;
      if (value && indicatorDate && typeof indicatorDate === "string") {
        value.indicatorDate = new Date(indicatorDate);
        data[key] = value;
      }
    });

    this.uid = uid;
    this.contractUid = contractUid;
    this.structured = structured;
    this.isStage = isStage;
    this.data = data;
    this.allAttachments = allAttachments;
  }

  /** Adiciona um registro de Aditivo aos movimentos da linha. */
  addAddtiveDataOf(
    row: ContractRowModel,
    addedQuantity: number,
    totalContract: number,
    user: UserModel
  ) {
    const keys = Object.keys(this.data);
    this.data[keys.length] = {
      date: new Date(),
      quantityApplied: addedQuantity,
      quantity: row.quantity,
      total: row.total,
      unitCost: row.unitCost,
      totalContract,
      type: ERowMovementTypes.ADDITIVE,
      user: {
        id: user.uid,
        name: user.name,
      },
    };
  }

  /** Adiciona um registro de Distrato aos movimentos da linha. */
  addCancellationDataOf(
    row: ContractRowModel,
    canceledQuantity: number,
    totalContract: number,
    user: UserModel
  ) {
    const keys = Object.keys(this.data);
    this.data[keys.length] = {
      date: new Date(),
      quantityApplied: canceledQuantity,
      quantity: row.quantity,
      total: row.total,
      unitCost: row.unitCost,
      totalContract,
      type: ERowMovementTypes.CANCELLATION,
      user: {
        id: user.uid,
        name: user.name,
      },
    };
  }

  /** Adiciona um registro de Alteração aos movimentos da linha. */
  addUpdatedDataOf(
    row: ContractRowModel,
    updatedQuantity: number,
    totalContract: number,
    user: UserModel
  ) {
    const keys = Object.keys(this.data);
    this.data[keys.length] = {
      date: new Date(),
      quantityApplied: updatedQuantity,
      quantity: row.quantity,
      total: row.total,
      unitCost: row.unitCost,
      totalContract,
      type: ERowMovementTypes.UPDATED,
      user: {
        id: user.uid,
        name: user.name,
      },
    };
  }

  /** Adiciona um registro de Aditivo aos movimentos da linha. */
  addDescriptionDataOf(
    row: ContractRowModel,
    oldDescription: string,
    user: UserModel
  ) {
    const keys = Object.keys(this.data);
    this.data[keys.length] = {
      date: new Date(),
      description: row.description,
      oldDescription,
      type: ERowMovementTypes.EDIT_DESCRIPTION,
      user: {
        id: user.uid,
        name: user.name,
      },
    };
  }

  groupAllAttachments() {
    const moviments = Object.values(this.data);
    const attachments: string[] = [];
    for (const moviment of moviments) {
      if (moviment.attachments) {
        attachments.push(...moviment.attachments);
      }
    }
    this.allAttachments = attachments;
  }

  toSave() {
    return {
      structured: this.structured,
      isStage: this.isStage,
      data: { ...this.data },
      allAttachments: this.allAttachments,
    };
  }

  static create(
    uid: string,
    data: Partial<ContractRowMovementModel>
  ): ContractRowMovementModel {
    return new ContractRowMovementModel(
      uid,
      data.contractUid,
      data.structured,
      data.isStage,
      data.data,
      data.allAttachments
    );
  }
}

export default ContractRowMovementModel;
